module.exports = __webpack_public_path__ + "static/media/USC_thumbnail.916e85b3.png";